import { render, staticRenderFns } from "./alerts-menu.vue?vue&type=template&id=5eb87a40&"
import script from "./alerts-menu.vue?vue&type=script&lang=js&"
export * from "./alerts-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports